// removed by extract-text-webpack-plugin
module.exports = {"root":"_3IzV27l","root_isLast":"_33ByK9u","root_isClassic":"_1A2STSz","root_isFirst":"_3qmRn1z","root_isPremium":"_25feWFH","root_isStandOut":"_213wrO1","trackingPixel":"us4iRN6","badge":"_2JCCqQx","featured":"_1ek2_MC","dateListed":"_3tEN-Gr","freshJob":"_1U-QcR0","highlight":"KJhKWux","title":"r5SacuT","titleLink":"_1OFaluu","advertiser":"HR3XFoW","content":"_161K-Aw","primary":"_3INaVUb","salary":"_3-qTIfd","secondary":"_3nz_AYs","bullets":"_11tuJpU","bullet":"feMC8Ke","shortDescription":"_2GUG24P","classification":"_3IP_abB","saveJob":"_2j4Do1F","logo":"_1RWfvxc","footer":"_6sZH95V"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultList/components/JobItem/JobItem.less
 ** module id = 806
 ** module chunks = 0
 **/